module.exports = __webpack_public_path__ + "img/448.33505448.jpg";